import {registerRoute as workbox_routing_registerRoute} from '/app/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkFirst as workbox_strategies_NetworkFirst} from '/app/node_modules/workbox-strategies/NetworkFirst.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from '/app/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/app/node_modules/workbox-strategies/CacheFirst.mjs';
import {StaleWhileRevalidate as workbox_strategies_StaleWhileRevalidate} from '/app/node_modules/workbox-strategies/StaleWhileRevalidate.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/app/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/app/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/app/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  "/worker-b8e102b8cc27c8af.js"
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/apple-app-site-association",
    "revision": "71b0f8dddb28b0f9a2cdb56df1757c83"
  },
  {
    "url": "/favicon.ico",
    "revision": "f493585e32c125c511a1a69e3a9095a1"
  },
  {
    "url": "/google65dd1b3adf6d391b.html",
    "revision": "370918fec4c35a9203065bb7b4a2f105"
  },
  {
    "url": "/icons/LF_LOGO.svg",
    "revision": "8ab116ebeced84a377144fc923829006"
  },
  {
    "url": "/icons/apple.svg",
    "revision": "ddc6d872e4baebcb7cfc677ea590f99e"
  },
  {
    "url": "/icons/apple/apple-icon-120.png",
    "revision": "548a28ce05cbb2212e336824b7632206"
  },
  {
    "url": "/icons/apple/apple-icon-152.png",
    "revision": "e7f2997719bb31e9e759a52af9e8284a"
  },
  {
    "url": "/icons/apple/apple-icon-167.png",
    "revision": "70ddcd00c250f5d2b7dd0f6d24d7e09d"
  },
  {
    "url": "/icons/apple/apple-icon-180.png",
    "revision": "c55221f7c5c052e728e0a4b0a1d807a9"
  },
  {
    "url": "/icons/apple/apple-icon-60.png",
    "revision": "ffaa7ce6f9a890aef4ba36d1feb266c8"
  },
  {
    "url": "/icons/apple/apple-icon-76.png",
    "revision": "a9400ba95e9211ae6c9eadcea447851e"
  },
  {
    "url": "/icons/brand_logos/de.svg",
    "revision": "4ed6a83b7084d8a7799df1ea4c33f1a4"
  },
  {
    "url": "/icons/brand_logos/fr.svg",
    "revision": "77c6836cd3f5a1d67759e64c5bd2c56c"
  },
  {
    "url": "/icons/burger_menu.svg",
    "revision": "800439bd343ac376d2b9e82cd2585dca"
  },
  {
    "url": "/icons/checkbox.svg",
    "revision": "71f8c2c0e0195bc7012564c67d73e1ea"
  },
  {
    "url": "/icons/checkbox_black.svg",
    "revision": "2ee6230c9d4642e4deb586d1c3d112e5"
  },
  {
    "url": "/icons/checked-circle.svg",
    "revision": "0e1438c65ae80f33bf18f03b28abf5fa"
  },
  {
    "url": "/icons/checked.svg",
    "revision": "259d7f826ce2fbdd1bb8661d7253c1ca"
  },
  {
    "url": "/icons/cookie.svg",
    "revision": "cb5b9095335346370fff4145e27b8c36"
  },
  {
    "url": "/icons/copy.png",
    "revision": "f7fa4020a54cea59bb33417fddb6ceb7"
  },
  {
    "url": "/icons/crossbar.svg",
    "revision": "22f39e8d91b195a7317aefbde8e39ace"
  },
  {
    "url": "/icons/empty-star.svg",
    "revision": "dbf86ed5a6fb163a75bd7fb7f1bfcb07"
  },
  {
    "url": "/icons/eye.svg",
    "revision": "3e05d14e6b8bcdd26e75f26aa7c99a1a"
  },
  {
    "url": "/icons/eyebar.svg",
    "revision": "b624e49fa07e7164c6df0beb02724bde"
  },
  {
    "url": "/icons/facebook.svg",
    "revision": "3a7dee39bfb14414066cc6351ff87e06"
  },
  {
    "url": "/icons/favicons/favicon-16x16.png",
    "revision": "f493585e32c125c511a1a69e3a9095a1"
  },
  {
    "url": "/icons/favicons/favicon-32x32.png",
    "revision": "5dbd41094e9bc8d4a0c4512660578843"
  },
  {
    "url": "/icons/favicons/favicon-96x96.png",
    "revision": "963db3f861a562d2313c933ba349ad26"
  },
  {
    "url": "/icons/favicons/favicon.ico",
    "revision": "f493585e32c125c511a1a69e3a9095a1"
  },
  {
    "url": "/icons/fourche_digi_white_150.svg",
    "revision": "b05552ba022bc8363dc19d7ab571ba68"
  },
  {
    "url": "/icons/full-star.svg",
    "revision": "7a52baea3eca6f20836f0bfc27546ebc"
  },
  {
    "url": "/icons/google.svg",
    "revision": "6f061bc32e12367b104a3267a65bad3d"
  },
  {
    "url": "/icons/infoTooltip.svg",
    "revision": "34bfc038d7fe95608cf8035ebff67d03"
  },
  {
    "url": "/icons/infoTooltipGreen.svg",
    "revision": "5375d01231233dba3b7e6e12d90a7f25"
  },
  {
    "url": "/icons/link.png",
    "revision": "2b47a01ed3ee8e6e2ec20c4ee9c0bbd9"
  },
  {
    "url": "/icons/societeAMission.svg",
    "revision": "339c6159c514740c4969be1f85d0b3e7"
  },
  {
    "url": "/icons/trashcan.svg",
    "revision": "75ae1ffd7266f0ff97de330912d8190e"
  },
  {
    "url": "/images/LAFOURCHE_LOGO.png",
    "revision": "0a51878547690d2a290a5c115ceee5f2"
  },
  {
    "url": "/images/TINY_500PX_ANNULABLE.jpg",
    "revision": "10801ad8da289933751d872b21756121"
  },
  {
    "url": "/images/alcohol-disclaimer.png",
    "revision": "17e3879fbfde88dda3caa47b14c46c0d"
  },
  {
    "url": "/images/app-mobile/badge-apple-store.png",
    "revision": "5402aa2aefdb3cdbe50c6695e23d1dfd"
  },
  {
    "url": "/images/app-mobile/badge-play-store.png",
    "revision": "d19f62052376a177143bf9bff9acc8ad"
  },
  {
    "url": "/images/app-mobile/laf-qrcode.png",
    "revision": "a329ff0f837ac6123cc4a1e665d5d046"
  },
  {
    "url": "/images/app-mobile/mobile-app-logo-heart.svg",
    "revision": "35d3b1567e0bb421cbf8be60cbd310c8"
  },
  {
    "url": "/images/app-mobile/mobile-screen-1-DES-COURSES-RAPIDES.svg",
    "revision": "26273bc097136d2b5a0762701a1a1532"
  },
  {
    "url": "/images/app-mobile/mobile-screen-2-UN-PAIMENT-SECURISE.svg",
    "revision": "095be5d7a6ac36115a367a782045de4c"
  },
  {
    "url": "/images/app-mobile/mobile-screen-3-LE-SUIVI-DE-MES-COMMANDES.svg",
    "revision": "30550e33d7c1ce80a3760a7b7d17140c"
  },
  {
    "url": "/images/app-mobile/mobile-screen-FAVORIS-L.png",
    "revision": "26849e7f58fcb7ff08796248e78ed864"
  },
  {
    "url": "/images/app-mobile/mobile-screen-PANIER-70-L.png",
    "revision": "dbc452a9d4e1290ffa4a045020a0be56"
  },
  {
    "url": "/images/app-mobile/mobile-screen-PAT-COMMENTS-L.png",
    "revision": "0568a95533b469ae6c140d9db2902ee9"
  },
  {
    "url": "/images/app-mobile/mobile-screen-PATES-MENU-L.png",
    "revision": "9d74beb21da0b281cb86f10b984b45b5"
  },
  {
    "url": "/images/app-mobile/mobile-screen-arrow-01.svg",
    "revision": "0d8ec464a10975adab3bae13715f3df3"
  },
  {
    "url": "/images/app-mobile/mobile-screen-arrow-02.svg",
    "revision": "ab44617c809d8c118552e36e7202ac82"
  },
  {
    "url": "/images/app-mobile/mobile-screen-arrow-03.svg",
    "revision": "ead90e2460193e044f5b5bb6d3706792"
  },
  {
    "url": "/images/apple-splash/apple-splash-1125-2436.jpg",
    "revision": "575adef8cbf2c7af92a2aeec9e7e0fef"
  },
  {
    "url": "/images/apple-splash/apple-splash-1136-640.jpg",
    "revision": "b8d549fcd972f2c6d03481b9e73e9f94"
  },
  {
    "url": "/images/apple-splash/apple-splash-1170-2532.jpg",
    "revision": "2547d19943c94f23129f030de2b3683e"
  },
  {
    "url": "/images/apple-splash/apple-splash-1242-2208.jpg",
    "revision": "6107d9182ed1f67300c788a1550f3dd3"
  },
  {
    "url": "/images/apple-splash/apple-splash-1242-2688.jpg",
    "revision": "debe9e8335b135a9ec61528d5e4f0948"
  },
  {
    "url": "/images/apple-splash/apple-splash-1284-2778.jpg",
    "revision": "6d28031a25666a67f634602adb8805c7"
  },
  {
    "url": "/images/apple-splash/apple-splash-1334-750.jpg",
    "revision": "3a7d427024b5abeb344aaf4b6ccd0de6"
  },
  {
    "url": "/images/apple-splash/apple-splash-1536-2048.jpg",
    "revision": "c4db4f2fa1d12b948d9d2a6a51788249"
  },
  {
    "url": "/images/apple-splash/apple-splash-1620-2160.jpg",
    "revision": "2caca6470c622e5a50be85b374880cc5"
  },
  {
    "url": "/images/apple-splash/apple-splash-1668-2224.jpg",
    "revision": "17fe7c007c0208fc1aa7e6917c3cb3d6"
  },
  {
    "url": "/images/apple-splash/apple-splash-1668-2388.jpg",
    "revision": "23d475ae4f6e98d071f9f812a019d63d"
  },
  {
    "url": "/images/apple-splash/apple-splash-1792-828.jpg",
    "revision": "8de520f09354e8e58a5d19846861dd07"
  },
  {
    "url": "/images/apple-splash/apple-splash-2048-1536.jpg",
    "revision": "fe44884473b9eb2f84f5e8dff21e56a4"
  },
  {
    "url": "/images/apple-splash/apple-splash-2048-2732.jpg",
    "revision": "6b3e9c1526eb785d02b553de85b62767"
  },
  {
    "url": "/images/apple-splash/apple-splash-2160-1620.jpg",
    "revision": "8b15e9992ea76a03c769ad809d78c8ba"
  },
  {
    "url": "/images/apple-splash/apple-splash-2208-1242.jpg",
    "revision": "78919463c55c683dc06e592bf2a47c11"
  },
  {
    "url": "/images/apple-splash/apple-splash-2224-1668.jpg",
    "revision": "8cc894d7bc88d34cec07bcd59a70e68f"
  },
  {
    "url": "/images/apple-splash/apple-splash-2388-1668.jpg",
    "revision": "d5b146a5717272737a99bf4ca243a299"
  },
  {
    "url": "/images/apple-splash/apple-splash-2436-1125.jpg",
    "revision": "d9b4a19a82cd1a3529c6c5c1b844a324"
  },
  {
    "url": "/images/apple-splash/apple-splash-2532-1170.jpg",
    "revision": "a48396fd63da540c16c7e6e0b5db80c8"
  },
  {
    "url": "/images/apple-splash/apple-splash-2688-1242.jpg",
    "revision": "8ec258a6f8db41ba9173a63cfae8aa41"
  },
  {
    "url": "/images/apple-splash/apple-splash-2732-2048.jpg",
    "revision": "a8a6ec7717029b49c43a1d0d5df7e45e"
  },
  {
    "url": "/images/apple-splash/apple-splash-2778-1284.jpg",
    "revision": "c7dfcac180fd5cbba3b1fef44171bf28"
  },
  {
    "url": "/images/apple-splash/apple-splash-640-1136.jpg",
    "revision": "1af40691ec74f414f41ae66c44b02129"
  },
  {
    "url": "/images/apple-splash/apple-splash-750-1334.jpg",
    "revision": "4211f1b081be451309c9f09096749bb9"
  },
  {
    "url": "/images/apple-splash/apple-splash-828-1792.jpg",
    "revision": "647dc2ecdae8377f69dd387dd166e2a5"
  },
  {
    "url": "/images/auroremarket-et-lafourche.png",
    "revision": "a0e245bc69c86e8981d4f2913eca8163"
  },
  {
    "url": "/images/bio_label.png",
    "revision": "7a17abd7ce03813d4c2ce47cdb65e6c3"
  },
  {
    "url": "/images/checkout/alert-info.svg",
    "revision": "d8cdc2e9d96db1099a496d1a5260f1c2"
  },
  {
    "url": "/images/checkout/amex.svg",
    "revision": "afbb2152aa77e301d16d32bbe2b6ea02"
  },
  {
    "url": "/images/checkout/apple-pay.svg",
    "revision": "8f0895fec501ef4e27821666bd46e0fd"
  },
  {
    "url": "/images/checkout/bank.svg",
    "revision": "5403d19857212f613daa41bd0af1aa4f"
  },
  {
    "url": "/images/checkout/cb.svg",
    "revision": "c239f1639e961b36297ce7b9180661fc"
  },
  {
    "url": "/images/checkout/mastercard.svg",
    "revision": "b61421372f3ee074076c259f09bacfeb"
  },
  {
    "url": "/images/checkout/payment-method.svg",
    "revision": "5275e7af8d828bbec93d42f726c71285"
  },
  {
    "url": "/images/checkout/paypal-brand.svg",
    "revision": "274307de760671388d0a05d445d9bbc9"
  },
  {
    "url": "/images/checkout/paypal-x2.png",
    "revision": "01621718c73c4ed67a5dbb10585053f8"
  },
  {
    "url": "/images/checkout/paypal.svg",
    "revision": "ca78ea9afd6ec4c564c910b6b57bc265"
  },
  {
    "url": "/images/checkout/visa.svg",
    "revision": "dbfe81537f90937cd78bfb410dbf7ef0"
  },
  {
    "url": "/images/coeurs.svg",
    "revision": "c3dd7a66bc84479c306cd5af5c4d0dc8"
  },
  {
    "url": "/images/default-collection-visual.jpg",
    "revision": "726c8cdc2f88d12b3a8ee29a5dcc4fd4"
  },
  {
    "url": "/images/default_rayon.svg",
    "revision": "4a994dff1e234ea64d2b6c6e2a7d0c12"
  },
  {
    "url": "/images/ecoscores/ecoscoreA.svg",
    "revision": "c5a71af892c4b418e75c164348dcc05a"
  },
  {
    "url": "/images/ecoscores/ecoscoreB.svg",
    "revision": "9a361e74357731f09a95eee021247069"
  },
  {
    "url": "/images/ecoscores/ecoscoreC.svg",
    "revision": "51389bd1749762af1c7c7b30b5fe9808"
  },
  {
    "url": "/images/ecoscores/ecoscoreD.svg",
    "revision": "d0d8d14fa3e3094149c2c335efa45cd9"
  },
  {
    "url": "/images/ecoscores/ecoscoreE.svg",
    "revision": "6f08e5d60acbd4d34a278bb663ae9607"
  },
  {
    "url": "/images/error.png",
    "revision": "9dba4be60be7b2741b7e4b84d0d6a423"
  },
  {
    "url": "/images/ft-start-confirmation.svg",
    "revision": "c845571fa67b46994651167ca603b594"
  },
  {
    "url": "/images/greenscores/green-score-A+.svg",
    "revision": "57430b535c1cb9c9f794fed48e29fb46"
  },
  {
    "url": "/images/greenscores/green-score-A.svg",
    "revision": "c1584ce9b00426d0d014d5323df3d6e6"
  },
  {
    "url": "/images/greenscores/green-score-B.svg",
    "revision": "8622be85c3707e271b5bf3116ba47811"
  },
  {
    "url": "/images/greenscores/green-score-C.svg",
    "revision": "d51e3e8a26684b99c537d95ce9fbbae6"
  },
  {
    "url": "/images/greenscores/green-score-D.svg",
    "revision": "d47b18dba11df43d562c0bc73d5c4979"
  },
  {
    "url": "/images/greenscores/green-score-E.svg",
    "revision": "fdffc711a89fb676752ceb7d264ffff5"
  },
  {
    "url": "/images/greenscores/green-score-F.svg",
    "revision": "d4c0036885f6c45c0fe67355d081b932"
  },
  {
    "url": "/images/header-ellipse.svg",
    "revision": "9565ddcda42ec53b56d460b740450526"
  },
  {
    "url": "/images/heart-red.svg",
    "revision": "92e745f2ad196d0b48369db4c8499165"
  },
  {
    "url": "/images/heart-text.svg",
    "revision": "6e62b32002b8d5891dff7a22ece55048"
  },
  {
    "url": "/images/heart-yellow.svg",
    "revision": "c5a1d0c5036ec1569367863301c7a090"
  },
  {
    "url": "/images/hearts-gift.png",
    "revision": "b540ee31a8f68f3798b443818f050f80"
  },
  {
    "url": "/images/logo-de.png",
    "revision": "4c43fca64ee952ba014d9408999f7e38"
  },
  {
    "url": "/images/logo-fr.png",
    "revision": "0a51878547690d2a290a5c115ceee5f2"
  },
  {
    "url": "/images/logo.svg",
    "revision": "ee82f3797b37c19bc1d97f8a8822bdd3"
  },
  {
    "url": "/images/manifest-icon-192.png",
    "revision": "52202c3ffb5604e73f29ac6296b81027"
  },
  {
    "url": "/images/manifest-icon-512.png",
    "revision": "c4c17be267a4d10ee59540951d59dc8b"
  },
  {
    "url": "/images/nutriscores/de/nutriscore-a-new-de.svg",
    "revision": "4cefcf57562569098bed9dddc5034345"
  },
  {
    "url": "/images/nutriscores/de/nutriscore-b-new-de.svg",
    "revision": "7e026e9c1135afa986ac58a6681d2025"
  },
  {
    "url": "/images/nutriscores/de/nutriscore-c-new-de.svg",
    "revision": "77aa54c26f8ece4cfdef5893157e046d"
  },
  {
    "url": "/images/nutriscores/de/nutriscore-d-new-de.svg",
    "revision": "d1c140e462e14858abfc426ed26530be"
  },
  {
    "url": "/images/nutriscores/de/nutriscore-e-new-de.svg",
    "revision": "fc91bed490a0281ab54f5f7edae3cbca"
  },
  {
    "url": "/images/nutriscores/fr/nutriscore-a-new-fr.svg",
    "revision": "e2e7386bbb4b9019d9d4231fede2d74e"
  },
  {
    "url": "/images/nutriscores/fr/nutriscore-b-new-fr.svg",
    "revision": "82dd68ef81e31a2d0d95e6f53a84eadc"
  },
  {
    "url": "/images/nutriscores/fr/nutriscore-c-new-fr.svg",
    "revision": "42e2abbaa68ecd7fb2d4747c8558d261"
  },
  {
    "url": "/images/nutriscores/fr/nutriscore-d-new-fr.svg",
    "revision": "1d2ca1a6e51dfc7710487cc901f3c9bf"
  },
  {
    "url": "/images/nutriscores/fr/nutriscore-e-new-fr.svg",
    "revision": "b92deacb3a0bedc73debee4e46241459"
  },
  {
    "url": "/images/nutriscores/ld/nutriscoreA-sm.png",
    "revision": "70c492d1a3990a51b7ba603d3a48e349"
  },
  {
    "url": "/images/nutriscores/ld/nutriscoreB-sm.png",
    "revision": "4aeadd97fa671cbe1b51f23b5033304d"
  },
  {
    "url": "/images/nutriscores/ld/nutriscoreC-sm.png",
    "revision": "5eeb16ef65ce08f425b59954833d29fd"
  },
  {
    "url": "/images/nutriscores/ld/nutriscoreD-sm.png",
    "revision": "f790ff0cc87278f17335aad4dafa6207"
  },
  {
    "url": "/images/nutriscores/ld/nutriscoreE-sm.png",
    "revision": "71c3e3af1984e4cd3cad60c203932306"
  },
  {
    "url": "/images/nutriscores/nutriscoreA-sm.png",
    "revision": "3ccc4aaffacc146a0b565370e2b1aaa7"
  },
  {
    "url": "/images/nutriscores/nutriscoreA.png",
    "revision": "588a34ef6cc7e39a57d6e714f099395b"
  },
  {
    "url": "/images/nutriscores/nutriscoreB-sm.png",
    "revision": "4071bd43de72b94a57db5cbacafa584c"
  },
  {
    "url": "/images/nutriscores/nutriscoreB.png",
    "revision": "d83ad0b3368528395d35eeb0e43a8aa6"
  },
  {
    "url": "/images/nutriscores/nutriscoreC-sm.png",
    "revision": "8434e30788039e2edb6a7835a0db37a1"
  },
  {
    "url": "/images/nutriscores/nutriscoreC.png",
    "revision": "346e96dcad69624dc4f0c36e05cbac17"
  },
  {
    "url": "/images/nutriscores/nutriscoreD-sm.png",
    "revision": "302d980fa81866805a0a62269eeead22"
  },
  {
    "url": "/images/nutriscores/nutriscoreD.png",
    "revision": "21735eef5fb4bd413fe68b4d4a4ef95e"
  },
  {
    "url": "/images/nutriscores/nutriscoreE-sm.png",
    "revision": "ecfab5d0ab96125e44df5dc029e2b314"
  },
  {
    "url": "/images/nutriscores/nutriscoreE.png",
    "revision": "e79080d629086cb25a7dd796f37d27cb"
  },
  {
    "url": "/images/search-header.svg",
    "revision": "e1f03cfa10adcf10bfcc9e14ed35e100"
  },
  {
    "url": "/images/text-mvnt.svg",
    "revision": "8e808cd219b29355b4864a9f4e856477"
  },
  {
    "url": "/images/yuka_logo_small.png",
    "revision": "4ea6f5d12bd0825e9b06b5a4092d5b97"
  },
  {
    "url": "/images/yukascores/0.svg",
    "revision": "d9c6462f6753becd4215ce0dd635048e"
  },
  {
    "url": "/images/yukascores/1.svg",
    "revision": "5c39f09e3062b3332ef823e40fee3e90"
  },
  {
    "url": "/images/yukascores/10.svg",
    "revision": "f69f51eda7c54f28759953d4c00020c4"
  },
  {
    "url": "/images/yukascores/100.svg",
    "revision": "21e9008a756a60063af8930c6c68643e"
  },
  {
    "url": "/images/yukascores/11.svg",
    "revision": "5d058cca5f68819de819fd27f1a9a616"
  },
  {
    "url": "/images/yukascores/12.svg",
    "revision": "66e37a51e1c6d1dc1dbbc0621ed26d0a"
  },
  {
    "url": "/images/yukascores/13.svg",
    "revision": "4c0944c6408d01d596d4d1a3da97de1f"
  },
  {
    "url": "/images/yukascores/14.svg",
    "revision": "71cb654ffcf88630ac02b9d619ea25d4"
  },
  {
    "url": "/images/yukascores/15.svg",
    "revision": "98c46b0be2d8d2c62bd3d1eefcc92517"
  },
  {
    "url": "/images/yukascores/16.svg",
    "revision": "e33d28435e3a17fce50574c8eff0e796"
  },
  {
    "url": "/images/yukascores/17.svg",
    "revision": "24c3a5cae3162f81f2ea844f8faebf13"
  },
  {
    "url": "/images/yukascores/18.svg",
    "revision": "82b7723b8b36224f4a4cce8ad7475638"
  },
  {
    "url": "/images/yukascores/19.svg",
    "revision": "0bb980cdd06eaf8a2bf1c3fd6af6aaff"
  },
  {
    "url": "/images/yukascores/2.svg",
    "revision": "7865d8cfceb62136790bbf6d26099277"
  },
  {
    "url": "/images/yukascores/20.svg",
    "revision": "e41289a044f8532f6240b1f52e281f94"
  },
  {
    "url": "/images/yukascores/21.svg",
    "revision": "cb92a6eec4a61e2d910babd21c899784"
  },
  {
    "url": "/images/yukascores/22.svg",
    "revision": "1264cfd877284ce0358cbdc5db2121ea"
  },
  {
    "url": "/images/yukascores/23.svg",
    "revision": "8ffada7cec1a21a8ee96b90bbd4bfa05"
  },
  {
    "url": "/images/yukascores/24.svg",
    "revision": "9a54d48c2778f71a8a7e6f718235170f"
  },
  {
    "url": "/images/yukascores/25.svg",
    "revision": "a58b96fe9db232a1015f180301f64de0"
  },
  {
    "url": "/images/yukascores/26.svg",
    "revision": "9620595bf097b79c435ff47384810a84"
  },
  {
    "url": "/images/yukascores/27.svg",
    "revision": "18a6023fe8f32639bd885d71588bc6dc"
  },
  {
    "url": "/images/yukascores/28.svg",
    "revision": "6462c723bb0a75b7f8568713ab41e8cc"
  },
  {
    "url": "/images/yukascores/29.svg",
    "revision": "e15b3815b00221ca9d526afada2155bd"
  },
  {
    "url": "/images/yukascores/3.svg",
    "revision": "eb26fc6f24d099c00ed06e1fa5141e13"
  },
  {
    "url": "/images/yukascores/30.svg",
    "revision": "c9c35db98d0c6c964eb77272ba6677e0"
  },
  {
    "url": "/images/yukascores/31.svg",
    "revision": "12c09cec1a747b1d37de6c2071c2eb71"
  },
  {
    "url": "/images/yukascores/32.svg",
    "revision": "9b63b9431550eb7f4842a9f3ef9fbeaf"
  },
  {
    "url": "/images/yukascores/33.svg",
    "revision": "388c12d6c7fe3d5cd4310699cd190435"
  },
  {
    "url": "/images/yukascores/34.svg",
    "revision": "4d52517aa4301b9f35411f32a27d4e9d"
  },
  {
    "url": "/images/yukascores/35.svg",
    "revision": "62d64402d11418775886c5e63117c774"
  },
  {
    "url": "/images/yukascores/36.svg",
    "revision": "9e7a3d1b09fe0b943a1f551781349ea7"
  },
  {
    "url": "/images/yukascores/37.svg",
    "revision": "b131c969bc2c920d7386f0ced1c2de0b"
  },
  {
    "url": "/images/yukascores/38.svg",
    "revision": "6aae3de23d52b9b863fa7e9845d98e23"
  },
  {
    "url": "/images/yukascores/39.svg",
    "revision": "2efda418ec63bcdc3f25f45956e4f94a"
  },
  {
    "url": "/images/yukascores/4.svg",
    "revision": "a177c270cdd3ad3f704539d297eba868"
  },
  {
    "url": "/images/yukascores/40.svg",
    "revision": "5d85e2e52d358e9884e52c5a6326820a"
  },
  {
    "url": "/images/yukascores/41.svg",
    "revision": "df2ca2f5e5851a7e2a41dd9a7dc672e6"
  },
  {
    "url": "/images/yukascores/42.svg",
    "revision": "a395748c042ee0bba23b4557461b1b33"
  },
  {
    "url": "/images/yukascores/43.svg",
    "revision": "49fdac5e5449b8bb552c61d00b9ea154"
  },
  {
    "url": "/images/yukascores/44.svg",
    "revision": "c4f1fd40af153c20b4710ed07e9b259b"
  },
  {
    "url": "/images/yukascores/45.svg",
    "revision": "8ee2654737b5f46fd46113de8652d991"
  },
  {
    "url": "/images/yukascores/46.svg",
    "revision": "3ec4ab62f2390b773827fbedcb8cf812"
  },
  {
    "url": "/images/yukascores/47.svg",
    "revision": "2a6c7717b50cfab63417d81d7acbbe04"
  },
  {
    "url": "/images/yukascores/48.svg",
    "revision": "e9d60548ddf39e4f077c9b4f226bf49e"
  },
  {
    "url": "/images/yukascores/49.svg",
    "revision": "be526cab79d7efdb21ad5d4dd9a17586"
  },
  {
    "url": "/images/yukascores/5.svg",
    "revision": "21e7816fdd8856940ecb942661e16414"
  },
  {
    "url": "/images/yukascores/50.svg",
    "revision": "490fd1258717f7abeb8c60e96ba93d6b"
  },
  {
    "url": "/images/yukascores/51.svg",
    "revision": "1ad4022e5460debb4090d467dda39c5a"
  },
  {
    "url": "/images/yukascores/52.svg",
    "revision": "9b0c65e1b98baf896427392bb813ecd8"
  },
  {
    "url": "/images/yukascores/53.svg",
    "revision": "09b42cbd63389307717596226e538499"
  },
  {
    "url": "/images/yukascores/54.svg",
    "revision": "26d9b6798e0a370a5e45ed1bd42f9a59"
  },
  {
    "url": "/images/yukascores/55.svg",
    "revision": "ac57dc08cfdab6b09dee3d4d15d49688"
  },
  {
    "url": "/images/yukascores/56.svg",
    "revision": "12b85a7dc99754af26558b05cdce8aff"
  },
  {
    "url": "/images/yukascores/57.svg",
    "revision": "1f1db3de1322b9c0badd66899d3993b7"
  },
  {
    "url": "/images/yukascores/58.svg",
    "revision": "ca60b8aec51a92712f082ed8a62b1cc8"
  },
  {
    "url": "/images/yukascores/59.svg",
    "revision": "2522e0cd5e358442fecc1c2798ef43a5"
  },
  {
    "url": "/images/yukascores/6.svg",
    "revision": "2e1852c5ca2e0c427ec58c502f1d7934"
  },
  {
    "url": "/images/yukascores/60.svg",
    "revision": "effb4604d7d2d89c8d427e024a6d99e0"
  },
  {
    "url": "/images/yukascores/61.svg",
    "revision": "5e717d6127e3de63e50b55f1ee6a5c6e"
  },
  {
    "url": "/images/yukascores/62.svg",
    "revision": "22b476e02ffa4431082641332f7a338d"
  },
  {
    "url": "/images/yukascores/63.svg",
    "revision": "4de097974d4bbfe0dbd36674c9796f4c"
  },
  {
    "url": "/images/yukascores/64.svg",
    "revision": "da55803066c59a7e0f29a14a8dcabceb"
  },
  {
    "url": "/images/yukascores/65.svg",
    "revision": "65a22a45ebcfeba8bc00897311614c07"
  },
  {
    "url": "/images/yukascores/66.svg",
    "revision": "d93e955f26b8e2c32bef663315cba158"
  },
  {
    "url": "/images/yukascores/67.svg",
    "revision": "44bc03c01c890122b830a705b1a7faf4"
  },
  {
    "url": "/images/yukascores/68.svg",
    "revision": "3e79d39366bcee214f8aa09a6c949ffc"
  },
  {
    "url": "/images/yukascores/69.svg",
    "revision": "951a90e84d5cccbc9a0896db24968e46"
  },
  {
    "url": "/images/yukascores/7.svg",
    "revision": "46b1f73789828da304e5c6815feb62e1"
  },
  {
    "url": "/images/yukascores/70.svg",
    "revision": "5591ab2622a22bc1ad93c548cf67b01b"
  },
  {
    "url": "/images/yukascores/71.svg",
    "revision": "9464259ba3aa3c353553734a71091dbc"
  },
  {
    "url": "/images/yukascores/72.svg",
    "revision": "95e864b14af09a26de42c7ec1771ca8c"
  },
  {
    "url": "/images/yukascores/73.svg",
    "revision": "a7043fcd18013d16c4beb47fee0727d6"
  },
  {
    "url": "/images/yukascores/74.svg",
    "revision": "674a39038994f69118fc02ad644d7753"
  },
  {
    "url": "/images/yukascores/75.svg",
    "revision": "d455a0304be0c1756d73f118ab5a1123"
  },
  {
    "url": "/images/yukascores/76.svg",
    "revision": "4989cf7d9c38915ca86d4fb050f08ca9"
  },
  {
    "url": "/images/yukascores/77.svg",
    "revision": "4e3babe6203915e095983c6be56b4561"
  },
  {
    "url": "/images/yukascores/78.svg",
    "revision": "20ec4ea1514da26c13bcf12e75699d11"
  },
  {
    "url": "/images/yukascores/79.svg",
    "revision": "4ef010518fd84eda8d54ace1dd6254b1"
  },
  {
    "url": "/images/yukascores/8.svg",
    "revision": "90bb4a061caa0264b69f3aad5ddd5471"
  },
  {
    "url": "/images/yukascores/80.svg",
    "revision": "ee6331dff7ad94ce0821a238caaba0eb"
  },
  {
    "url": "/images/yukascores/81.svg",
    "revision": "f038bc51e687432397969a4c196da711"
  },
  {
    "url": "/images/yukascores/82.svg",
    "revision": "8ed6ba55cf5d926b76e761c5906758b8"
  },
  {
    "url": "/images/yukascores/83.svg",
    "revision": "da996d9337d3077e2286da531c409dc2"
  },
  {
    "url": "/images/yukascores/84.svg",
    "revision": "52ef3dfebd1c2cd50d979a41d53e198d"
  },
  {
    "url": "/images/yukascores/85.svg",
    "revision": "982748e612c2d16b82c19b1ca104e631"
  },
  {
    "url": "/images/yukascores/86.svg",
    "revision": "55ce184277ebde3fff9c03b1b840dfda"
  },
  {
    "url": "/images/yukascores/87.svg",
    "revision": "e8b9497a2c7013a6b01995937f3505cb"
  },
  {
    "url": "/images/yukascores/88.svg",
    "revision": "c0dd3468e8a2f63d0d306450b92d94f6"
  },
  {
    "url": "/images/yukascores/89.svg",
    "revision": "774690fff629614240a4e78a0162bd97"
  },
  {
    "url": "/images/yukascores/9.svg",
    "revision": "5453d77fe37620ca7a72565b9c391ecc"
  },
  {
    "url": "/images/yukascores/90.svg",
    "revision": "ee5766c65906d6143bb91e605015c445"
  },
  {
    "url": "/images/yukascores/91.svg",
    "revision": "60f3bc629f74ca048c77c37f7e32e234"
  },
  {
    "url": "/images/yukascores/92.svg",
    "revision": "fd89335ea83d6b97b1cb8a777ceab9ae"
  },
  {
    "url": "/images/yukascores/93.svg",
    "revision": "f8a709a752c1be9bafa143b21014dbe0"
  },
  {
    "url": "/images/yukascores/94.svg",
    "revision": "835940969d524471497a0cb714d49000"
  },
  {
    "url": "/images/yukascores/95.svg",
    "revision": "58c28de13b1de5fba93609e23b45f659"
  },
  {
    "url": "/images/yukascores/96.svg",
    "revision": "e309e38de4bad265553b1ea883c06003"
  },
  {
    "url": "/images/yukascores/97.svg",
    "revision": "2c764f263e8516e6ef9149a1a120e833"
  },
  {
    "url": "/images/yukascores/98.svg",
    "revision": "2071e2402d4ceb5dea687627a99f1403"
  },
  {
    "url": "/images/yukascores/99.svg",
    "revision": "f23634a9847d61cf757cb946905aaedf"
  },
  {
    "url": "/manifest.webmanifest",
    "revision": "1c72015a6c40c012c329ea9bde12945d"
  },
  {
    "url": "/robots.txt",
    "revision": "dd65e86eac11e934c468dc1c55282304"
  },
  {
    "url": "/wonderpush-worker-loader.min.js",
    "revision": "e28a9eee3464e1dffda0fbd748c26519"
  },
  {
    "url": "/wonderpush.min.html",
    "revision": "6ae553d5c039ef390f36e852d0b902fd"
  },
  {
    "url": "/worker-b8e102b8cc27c8af.js",
    "revision": "0202aecf04884e274063167939d016c0"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/dynamic-css-manifest.json",
    "revision": "d751713988987e9331980363e24189ce"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/ESOwwCKRC5TOHLK5Qd1V2/_buildManifest.js",
    "revision": "1c5d13388e52889aaf54c75dd7f86d2b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/ESOwwCKRC5TOHLK5Qd1V2/_ssgManifest.js",
    "revision": "b6652df95db52feb4daf4eca35380933"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1155-a125426b8dd10454.js",
    "revision": "a125426b8dd10454"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1161.19ee6ddc9692b227.js",
    "revision": "19ee6ddc9692b227"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1198.aa1b0d8ae5057d82.js",
    "revision": "aa1b0d8ae5057d82"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1287.b1f7778f484cb6db.js",
    "revision": "b1f7778f484cb6db"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1515.d92aa21d9cc91abe.js",
    "revision": "d92aa21d9cc91abe"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1552-beec3cf2011bad0f.js",
    "revision": "beec3cf2011bad0f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1570.33156404b317eeae.js",
    "revision": "33156404b317eeae"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1632.d839145519b29e33.js",
    "revision": "d839145519b29e33"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1667.d4930524053b0834.js",
    "revision": "d4930524053b0834"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1674.f004b3ceec6fcecc.js",
    "revision": "f004b3ceec6fcecc"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/169.68c7fee97660ba3c.js",
    "revision": "68c7fee97660ba3c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1809.951449f4d6510698.js",
    "revision": "951449f4d6510698"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1810.645f8f9ef2acfae2.js",
    "revision": "645f8f9ef2acfae2"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1968.9bf4094d2488e176.js",
    "revision": "9bf4094d2488e176"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/1b041c9c.55d83b5f68480252.js",
    "revision": "55d83b5f68480252"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2014.7d921c8ba3c60a7c.js",
    "revision": "7d921c8ba3c60a7c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2015-241448fb6e6d95db.js",
    "revision": "241448fb6e6d95db"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2141.d18d1fd629e4f34c.js",
    "revision": "d18d1fd629e4f34c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2312.1026e54480520e47.js",
    "revision": "1026e54480520e47"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2346-b3e0f009c6ea1681.js",
    "revision": "b3e0f009c6ea1681"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2361.20c91673e9988083.js",
    "revision": "20c91673e9988083"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2390.c660a9f4b48fd453.js",
    "revision": "c660a9f4b48fd453"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2439.0a6ddc3dea189139.js",
    "revision": "0a6ddc3dea189139"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2577.4f31076ca03c6808.js",
    "revision": "4f31076ca03c6808"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2592.d0b1cf922c6289f4.js",
    "revision": "d0b1cf922c6289f4"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2686.c91d2bd402e31ff0.js",
    "revision": "c91d2bd402e31ff0"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2720.6caa14730b2a96f4.js",
    "revision": "6caa14730b2a96f4"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2820.09db59665809ffd7.js",
    "revision": "09db59665809ffd7"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2945.cdd3d7591a6f7a26.js",
    "revision": "cdd3d7591a6f7a26"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/2964.032014953b3cf608.js",
    "revision": "032014953b3cf608"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/297.c75f90fe9d5ce179.js",
    "revision": "c75f90fe9d5ce179"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3062-1a43ad4a219bff2b.js",
    "revision": "1a43ad4a219bff2b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3075.4517e885c21a1a53.js",
    "revision": "4517e885c21a1a53"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3172.a6a71c710a7934de.js",
    "revision": "a6a71c710a7934de"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3204.5cd05df7b97ed74c.js",
    "revision": "5cd05df7b97ed74c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3286.86b11baa9fae6432.js",
    "revision": "86b11baa9fae6432"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3324.558291402f882ce7.js",
    "revision": "558291402f882ce7"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3579.a4b294ad78b0bd1d.js",
    "revision": "a4b294ad78b0bd1d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3624.f30a0feaf1d24dfa.js",
    "revision": "f30a0feaf1d24dfa"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3656.276903df5a801f0f.js",
    "revision": "276903df5a801f0f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/367.a043336b5b8d62ad.js",
    "revision": "a043336b5b8d62ad"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3742.e1b08941f8ad09fb.js",
    "revision": "e1b08941f8ad09fb"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3755.2af89476e71a3b11.js",
    "revision": "2af89476e71a3b11"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3827.aeddf9ca32a692b5.js",
    "revision": "aeddf9ca32a692b5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3884.70365e1b3b945e79.js",
    "revision": "70365e1b3b945e79"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3892.9d98b3418dd0280c.js",
    "revision": "9d98b3418dd0280c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3915.92680cc5f81b7833.js",
    "revision": "92680cc5f81b7833"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3930-e331fc68a9565959.js",
    "revision": "e331fc68a9565959"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/3988-2b3faeeab04ec261.js",
    "revision": "2b3faeeab04ec261"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4152.410f2bbf0a0ee247.js",
    "revision": "410f2bbf0a0ee247"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4165.2fbb1cb051848f04.js",
    "revision": "2fbb1cb051848f04"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4215.a64da9d2628fa3f5.js",
    "revision": "a64da9d2628fa3f5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/429.0751fa0c750b03ee.js",
    "revision": "0751fa0c750b03ee"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4512.d5a2648326c055b8.js",
    "revision": "d5a2648326c055b8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4533.43f7e62667b68a25.js",
    "revision": "43f7e62667b68a25"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4621.b2a6f63d2a336edd.js",
    "revision": "b2a6f63d2a336edd"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4622.8006b577f556ce25.js",
    "revision": "8006b577f556ce25"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4690.5b1d6bffa5b77b99.js",
    "revision": "5b1d6bffa5b77b99"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4694.4001bb054b3cea65.js",
    "revision": "4001bb054b3cea65"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4719.0d1e92139be581a8.js",
    "revision": "0d1e92139be581a8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4804.6ca43b6672e8d72a.js",
    "revision": "6ca43b6672e8d72a"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/487-3a4b3d11587bfd74.js",
    "revision": "3a4b3d11587bfd74"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/4936-5dc492c8ce73bd86.js",
    "revision": "5dc492c8ce73bd86"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5044.0bd4d2b12b638574.js",
    "revision": "0bd4d2b12b638574"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5261.5ddbe88f70986950.js",
    "revision": "5ddbe88f70986950"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5279-5f52537e38fac8de.js",
    "revision": "5f52537e38fac8de"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5393.3b6ae2dc6313b459.js",
    "revision": "3b6ae2dc6313b459"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5432.189dde8e9be44d9b.js",
    "revision": "189dde8e9be44d9b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5558.ccac149383500150.js",
    "revision": "ccac149383500150"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5571-f027b254b03a6ccf.js",
    "revision": "f027b254b03a6ccf"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5599.cf1dfac2ec1f489a.js",
    "revision": "cf1dfac2ec1f489a"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5631.b8b62bdbe13c8b8c.js",
    "revision": "b8b62bdbe13c8b8c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/56c12eb5-3dbbe526f9626b1f.js",
    "revision": "3dbbe526f9626b1f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5722.ffdef3ac85e39650.js",
    "revision": "ffdef3ac85e39650"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5732.aa15f202b29421e6.js",
    "revision": "aa15f202b29421e6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5769.851436f977a765c4.js",
    "revision": "851436f977a765c4"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5844-cdcf10808330ea70.js",
    "revision": "cdcf10808330ea70"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/5990.293068a7edc4c5c3.js",
    "revision": "293068a7edc4c5c3"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6028.4ea1014dafc4a7e5.js",
    "revision": "4ea1014dafc4a7e5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6087.1abc23d909768cf0.js",
    "revision": "1abc23d909768cf0"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/61.c32b681d6b3d6f67.js",
    "revision": "c32b681d6b3d6f67"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6115.ec54b32bbc8b1421.js",
    "revision": "ec54b32bbc8b1421"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6134.52b71297a2c15da2.js",
    "revision": "52b71297a2c15da2"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6148.224177954287484a.js",
    "revision": "224177954287484a"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6156.7385235f376ee8a8.js",
    "revision": "7385235f376ee8a8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6178.9c32b2410fbd2185.js",
    "revision": "9c32b2410fbd2185"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6192.a82c4f171af8e6f1.js",
    "revision": "a82c4f171af8e6f1"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6222.c6beaaece591153c.js",
    "revision": "c6beaaece591153c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/624.ea1813d37f62d071.js",
    "revision": "ea1813d37f62d071"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6301.19ea46e6a2892c6f.js",
    "revision": "19ea46e6a2892c6f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6327.035c2a9627e14ca9.js",
    "revision": "035c2a9627e14ca9"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6331.bc0cc1f3793d10b5.js",
    "revision": "bc0cc1f3793d10b5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6354.99a5dbfea27cac45.js",
    "revision": "99a5dbfea27cac45"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6397.fb1a5dc3645ad836.js",
    "revision": "fb1a5dc3645ad836"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6445.a450e5304d547a48.js",
    "revision": "a450e5304d547a48"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6498.40560f5c8b5258d6.js",
    "revision": "40560f5c8b5258d6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6528-4ecaa7a5853c4c2b.js",
    "revision": "4ecaa7a5853c4c2b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6585.51b227c27dc0a945.js",
    "revision": "51b227c27dc0a945"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/671.95f44753435dcffe.js",
    "revision": "95f44753435dcffe"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6727.36a28deb428bdc96.js",
    "revision": "36a28deb428bdc96"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6765.ea369106deb9a9ee.js",
    "revision": "ea369106deb9a9ee"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6937.968b93fb7e43ecb6.js",
    "revision": "968b93fb7e43ecb6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/6971.810e1e44a86e7ca8.js",
    "revision": "810e1e44a86e7ca8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7037.38741ee8f040908b.js",
    "revision": "38741ee8f040908b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7057.111b60265a6132de.js",
    "revision": "111b60265a6132de"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/71-738d21f09132620d.js",
    "revision": "738d21f09132620d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7132-31bcb3f32615dd97.js",
    "revision": "31bcb3f32615dd97"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7222.814511c40aa8b6ee.js",
    "revision": "814511c40aa8b6ee"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/732-e2482b7bf9fefa4f.js",
    "revision": "e2482b7bf9fefa4f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7394.3edaea122652c7b6.js",
    "revision": "3edaea122652c7b6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7396.6798bf585feba8f3.js",
    "revision": "6798bf585feba8f3"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7620.db7783dc99db41bc.js",
    "revision": "db7783dc99db41bc"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7674.4cfe8b4d24bf7944.js",
    "revision": "4cfe8b4d24bf7944"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7761.564b12a1b89b17c4.js",
    "revision": "564b12a1b89b17c4"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7892.0d582fb3de929b78.js",
    "revision": "0d582fb3de929b78"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7930.b650a7f09ae4f765.js",
    "revision": "b650a7f09ae4f765"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/7938.2913f14ee825f416.js",
    "revision": "2913f14ee825f416"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8306.a5fe5f30df28d376.js",
    "revision": "a5fe5f30df28d376"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8447.f4f53dd24ec98017.js",
    "revision": "f4f53dd24ec98017"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8562.8f6727803bd6879c.js",
    "revision": "8f6727803bd6879c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/862.d15fe369949ec8a2.js",
    "revision": "d15fe369949ec8a2"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8780.f6d06a986820a5ee.js",
    "revision": "f6d06a986820a5ee"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8842.3ff35572ce90095a.js",
    "revision": "3ff35572ce90095a"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8903.138c215a91cbd9b9.js",
    "revision": "138c215a91cbd9b9"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8905.57c46a05d930ea34.js",
    "revision": "57c46a05d930ea34"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8962.69c7d173d328345f.js",
    "revision": "69c7d173d328345f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/8990.d88e62b995a14854.js",
    "revision": "d88e62b995a14854"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9074.c690fc4d0af0802c.js",
    "revision": "c690fc4d0af0802c"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9312.62d9083be2a5d36e.js",
    "revision": "62d9083be2a5d36e"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9364-ff8795f160c6b0b7.js",
    "revision": "ff8795f160c6b0b7"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9374.c9d1cafc5e0c9518.js",
    "revision": "c9d1cafc5e0c9518"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9409.dfcaf2ef92c25810.js",
    "revision": "dfcaf2ef92c25810"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9502.60b2338645c4fae8.js",
    "revision": "60b2338645c4fae8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9620.ca95364d056afdc8.js",
    "revision": "ca95364d056afdc8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9651.033bf9789e1d674b.js",
    "revision": "033bf9789e1d674b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9697.2f9fdd4150da7979.js",
    "revision": "2f9fdd4150da7979"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/971.fd94b7d49e0443b5.js",
    "revision": "fd94b7d49e0443b5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9763.969d1859a134f671.js",
    "revision": "969d1859a134f671"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9784.144a523fb8fca86a.js",
    "revision": "144a523fb8fca86a"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9796.5bc2176645b3a0f8.js",
    "revision": "5bc2176645b3a0f8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9804.050249dcd8822ed7.js",
    "revision": "050249dcd8822ed7"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9886.3dedda154ffacb27.js",
    "revision": "3dedda154ffacb27"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/9924-e468af65280526c1.js",
    "revision": "e468af65280526c1"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/framework-f42d5b916cc5426e.js",
    "revision": "f42d5b916cc5426e"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/main-8e456f4ad635519d.js",
    "revision": "8e456f4ad635519d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/404-55e15785bed4f084.js",
    "revision": "55e15785bed4f084"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/_error-2972cc7a199c7be6.js",
    "revision": "2972cc7a199c7be6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/a/refer-a-friend/redeem-5a2fe4dfd15a6873.js",
    "revision": "5a2fe4dfd15a6873"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account-dc971a16c632ec33.js",
    "revision": "dc971a16c632ec33"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/%5Bslug%5D-ee29cf76b4504592.js",
    "revision": "ee29cf76b4504592"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/addresses-95bd9877a149eb7d.js",
    "revision": "95bd9877a149eb7d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/informations-bbc142f6dfdef82f.js",
    "revision": "bbc142f6dfdef82f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/login-e1c68d698631e372.js",
    "revision": "e1c68d698631e372"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/orders-1153316b5d161458.js",
    "revision": "1153316b5d161458"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/orders/%5Bid%5D-dc00fef040fe2216.js",
    "revision": "dc00fef040fe2216"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/payment-methods-1904dbfd24d1d0e5.js",
    "revision": "1904dbfd24d1d0e5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/personal-data-ef9a4c061cf2f3c8.js",
    "revision": "ef9a4c061cf2f3c8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/register/congrats-7c678188f24e6e18.js",
    "revision": "7c678188f24e6e18"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/register/flow-39c8a56238b0855e.js",
    "revision": "39c8a56238b0855e"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/reset-password-b63e368237437031.js",
    "revision": "b63e368237437031"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/account/review-products-085f51e93c5ceb82.js",
    "revision": "085f51e93c5ceb82"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/chatbot-9d08bb763e3fa879.js",
    "revision": "9d08bb763e3fa879"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/draft-product-0a2ea983cf1d2fc9.js",
    "revision": "0a2ea983cf1d2fc9"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/draft-product/%5Bslug%5D-4dd321d2a2dfea37.js",
    "revision": "4dd321d2a2dfea37"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/home-e85fe8a15f8f9ed1.js",
    "revision": "e85fe8a15f8f9ed1"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/product-polling-769b8cbd4371e941.js",
    "revision": "769b8cbd4371e941"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/result-eee58d4aefd3a8cc.js",
    "revision": "eee58d4aefd3a8cc"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/private-label/result/%5Bslug%5D-b48cbe6738b1fdcf.js",
    "revision": "b48cbe6738b1fdcf"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/apps/slice-simulator-0ef93d9cb81ca6f8.js",
    "revision": "0ef93d9cb81ca6f8"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/cart-c5f7593485ed3379.js",
    "revision": "c5f7593485ed3379"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/checkout/confirmation-ab6117e66d2ad245.js",
    "revision": "ab6117e66d2ad245"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/checkout/delivery-be963000d18d7ed5.js",
    "revision": "be963000d18d7ed5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/checkout/payment-bb2f7e96fe24a6a9.js",
    "revision": "bb2f7e96fe24a6a9"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/checkout/processing-7c16332ada833b7d.js",
    "revision": "7c16332ada833b7d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/checkout/register-8db0b46ae1c4b168.js",
    "revision": "8db0b46ae1c4b168"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/collections-list-3af049a657ec92fb.js",
    "revision": "3af049a657ec92fb"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/collections/%5BcollectionHandle%5D-270d271a60997946.js",
    "revision": "270d271a60997946"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/first-order-form-03c3ef9dbd47e3f3.js",
    "revision": "03c3ef9dbd47e3f3"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/first-order-form/congrats-f2190bea1422c93d.js",
    "revision": "f2190bea1422c93d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/home-91855d659ba82110.js",
    "revision": "91855d659ba82110"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/index-b30889447669dcac.js",
    "revision": "b30889447669dcac"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/lp/%5Bslug%5D-1e407b4a31e404aa.js",
    "revision": "1e407b4a31e404aa"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/%5Bslug%5D-cd4e833f7eea24a5.js",
    "revision": "cd4e833f7eea24a5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/manage-my-subscription-ea7bba9e8bc3d60d.js",
    "revision": "ea7bba9e8bc3d60d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/manage-my-subscription/change-subscription-d7f174c75f98870b.js",
    "revision": "d7f174c75f98870b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/my-lists-2cc794a3508ad147.js",
    "revision": "2cc794a3508ad147"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/my-lists/%5Bid%5D-1e5e09f1d021c977.js",
    "revision": "1e5e09f1d021c977"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/order-again-43c579494bda0bf0.js",
    "revision": "43c579494bda0bf0"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/referral-e5ba5d0a0e59cd59.js",
    "revision": "e5ba5d0a0e59cd59"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/suggestions-648b4269a8dea57e.js",
    "revision": "648b4269a8dea57e"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/telecharger-application-f94bc4c6c11811eb.js",
    "revision": "f94bc4c6c11811eb"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/tracking-4b79e97708493b5b.js",
    "revision": "4b79e97708493b5b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/pages/untrack-statistics-1be709071b02faf7.js",
    "revision": "1be709071b02faf7"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/payment/3ds-5b88bd8f9922dc66.js",
    "revision": "5b88bd8f9922dc66"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/product-basket/%5Bslug%5D-21d116724b5036b5.js",
    "revision": "21d116724b5036b5"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/products/%5Bhandle%5D-e795e00cd2eb61a0.js",
    "revision": "e795e00cd2eb61a0"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/qa-9140abc0e85c6d2d.js",
    "revision": "9140abc0e85c6d2d"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/qa/home-page-3f782fe872251776.js",
    "revision": "3f782fe872251776"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/qa/landing-page-c9b1e3a6aab7ee57.js",
    "revision": "c9b1e3a6aab7ee57"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/qa/page-d37ff33866ae2af4.js",
    "revision": "d37ff33866ae2af4"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/qa/side-panels-7dcd875f4999f1ea.js",
    "revision": "7dcd875f4999f1ea"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/search-a6a402d8a623b9a3.js",
    "revision": "a6a402d8a623b9a3"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/shared-list-f0ee5d5dc342861b.js",
    "revision": "f0ee5d5dc342861b"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/pages/shared-list/%5Bid%5D-048070ced2412324.js",
    "revision": "048070ced2412324"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/polyfills-42372ed130431b0a.js",
    "revision": "846118c33b2c0e922d7b3a7676f81f6f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/chunks/webpack-43040a5901986b4f.js",
    "revision": "43040a5901986b4f"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/css/a596c49b142699c6.css",
    "revision": "a596c49b142699c6"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/media/facebook.6d5918347c4c3b447c9aed072de77ceb.svg",
    "revision": "ESOwwCKRC5TOHLK5Qd1V2"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/media/google.6f1394b0b1ee466339b62cd619a460c1.svg",
    "revision": "ESOwwCKRC5TOHLK5Qd1V2"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/media/layers-2x.9859cd12.png",
    "revision": "9859cd12"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/media/layers.ef6db872.png",
    "revision": "ef6db872"
  },
  {
    "url": "https://cdn.lafourche.fr/_next/static/media/marker-icon.d577052a.png",
    "revision": "d577052a"
  }
], {
  "ignoreURLParametersMatching": [/^utm_/, /^fbclid$/]
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url", plugins: [{ cacheWillUpdate: async ({ response: e })=>e && "opaqueredirect" === e.type ? new Response(e.body, { status: 200, statusText: "OK", headers: e.headers }) : e }] }), 'GET');
workbox_routing_registerRoute("/", new workbox_strategies_NetworkFirst({ "cacheName":"start-url","networkTimeoutSeconds":1, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 1, maxAgeSeconds: 600 })] }), 'GET');
workbox_routing_registerRoute("/home", new workbox_strategies_NetworkFirst({ "cacheName":"start-url","networkTimeoutSeconds":1, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 1, maxAgeSeconds: 600 })] }), 'GET');
workbox_routing_registerRoute(/^https:\/\/fonts\.(?:googleapis|gstatic)\.com\/.*/i, new workbox_strategies_CacheFirst({ "cacheName":"google-fonts", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 10, maxAgeSeconds: 2592000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:eot|otf|ttc|ttf|woff|woff2|font.css)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-font-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 10, maxAgeSeconds: 2592000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:jpg|jpeg|gif|png|svg|ico|webp)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-image-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 64, maxAgeSeconds: 2592000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:js)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-js-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 2592000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:css|less)$/i, new workbox_strategies_StaleWhileRevalidate({ "cacheName":"static-style-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 2592000 })] }), 'GET');
workbox_routing_registerRoute(/\.(?:json|xml|csv)$/i, new workbox_strategies_NetworkFirst({ "cacheName":"static-data-assets", plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 3600 })] }), 'GET');
workbox_routing_registerRoute(/.*/i, new workbox_strategies_NetworkFirst({ "cacheName":"others","networkTimeoutSeconds":10, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 32, maxAgeSeconds: 600 })] }), 'GET');




